import { render, staticRenderFns } from "./codepage.vue?vue&type=template&id=3a4e6568&"
import script from "./codepage.vue?vue&type=script&lang=js&"
export * from "./codepage.vue?vue&type=script&lang=js&"
import style0 from "./codepage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports